import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "117",
  height: "119",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FFFFFE",
      d: "M2.844 19.889h15.212a1.85 1.85 0 0 0 1.85-1.833V2.844a1.85 1.85 0 0 0-3.163-1.296L1.53 16.76a1.85 1.85 0 0 0 .292 2.834c.303.202.658.293 1.022.294m13.38-3.683H7.287l8.937-8.92zM44.758 17.595a1.85 1.85 0 0 1 0 3.682H28.284a1.85 1.85 0 0 1 0-3.682zm0 9.214a1.85 1.85 0 0 1 0 3.682H9.735a1.85 1.85 0 0 1 0-3.682zm-3.639 9.836a1.85 1.85 0 0 1 0 3.682H9.735a1.85 1.85 0 0 1 0-3.682zm-2 9.835a1.85 1.85 0 0 1 0 3.683H9.735a1.85 1.85 0 0 1 0-3.682zm3.901 9.837a1.85 1.85 0 0 1 1.191 3.084c-.309.34 1.48.553 1.022.597H9.735a1.85 1.85 0 0 1 0-3.681zm6 9.213a1.85 1.85 0 0 1 1.671 1.841c0 .46 1.618.289 1.309.629s-.542-.044-1 0h1.5l-.5 1.212H9.735a1.85 1.85 0 0 1 0-3.682z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-width": "4",
      d: "M53 26.078V2.475H18.333L2.475 17.595v61.59H29"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-width": "5",
      d: "M52.631 67.745V79"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-width": "4",
      d: "M14 112.109a43.51 43.51 0 0 1 18.556-35.667l.549-.378a9.71 9.71 0 0 1 10.377-.206l.02.011a41.38 41.38 0 0 0 41.996 0l.02-.011a9.72 9.72 0 0 1 10.376.206h.001a43.52 43.52 0 0 1 19.1 35.379l.005.666v.001a4.89 4.89 0 0 1-4.891 4.89H18.891l-.243-.006A4.895 4.895 0 0 1 14 112.11zM64.5 23c13.393 0 24.25 10.857 24.25 24.25S77.893 71.5 64.5 71.5 40.25 60.643 40.25 47.25 51.107 23 64.5 23Z"
    }, null, -1)
  ])))
}
export default { render: render }